import React, {useState, useEffect} from 'react';
import Navigation from './Navigation';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import orderingfood from './Images/ordering-food.png';
import { Container, Row, Col } from 'react-bootstrap';
import CreatePostModal from './modals/CreatePostModal';

const Marketplace = () => {
    const[isLoggedIn, setIsLoggedIn] = useState(false);
    const[isCreatePostModalVisible, setIsCreatePostModalVisible] = useState(false);

    useEffect(() => {
        firebase.auth().onAuthStateChanged((user) => {
            if(!user){
              setIsLoggedIn(false)
            } else {
              setIsLoggedIn(true)
            }
        })
    }, [isLoggedIn])
  return (
    <div className="coming-soon-page">
        <header>
            <h1 className='coming-soon-heading'>Still Cooking. Coming Soon: The Cuisn Marketplace</h1>
        </header>
        <div>
            <img src={orderingfood} alt="Hero" className="hero-image" />
            <div className="overview">
                <h2>Discover a World of Culinary Delights</h2>
                <p>Experience a new way to explore and indulge in a wide variety of mouthwatering dishes from talented local chefs. Discover the perfect flavors that suit your palate and satisfy your cravings. Showcase your culinary skills and reach a wider audience of food enthusiasts. Expand your customer base and gain exposure to food lovers.</p>
            </div>
        </div> 

        <h2 className='why-cuisn-marketplace'>Why Cuisn Marketplace?</h2>
        <Container fluid>
            <Row>
                <Col xs={12} sm={12} md={6} lg={4}>
                    <div className="feature-card">
                        <h3>For Foodies</h3>
                        <ul>
                            <li>Access to a diverse selection of unique and delicious dishes.</li>
                            <li>Convenient ordering options for a seamless dining experience.</li>
                            <li>Opportunity to explore new flavors and discover hidden culinary gems.</li>
                            <li>Engage with a vibrant food community and share your experiences.</li>
                        </ul>
                    </div>
                </Col>
                <Col xs={12} sm={12} md={6} lg={4}>
                    <div className="feature-card">
                        <h3>For Chefs</h3>
                        <ul>
                            <li>Showcase your culinary skills and reach a wider audience of food enthusiasts.</li>
                            <li>Opportunity to grow your brand and increase your business revenue.</li>
                            <li>Connect with like-minded chefs, exchange ideas, and collaborate.</li>
                            <li>Receive valuable feedback from customers to improve your offerings.</li>
                        </ul>
                    </div>
                </Col>
                <Col xs={12} sm={12} md={6} lg={4}>
                    <div className="feature-card">
                        <h3>For Other Food Service Vendors</h3>
                        <ul>
                            <li>Expand your customer base and gain exposure to foodies and chefs.</li>
                            <li>Easy listing process for your cooking products and kitchen essentials.</li>
                            <li>Boost sales by offering special deals and discounts.</li>
                            <li>Connect with chefs and collaborate on unique product offerings.</li>
                        </ul>
                    </div>
                </Col>
            </Row>
        </Container>
        <CreatePostModal isCreatePostModalVisible={isCreatePostModalVisible} setIsCreatePostModalVisible={setIsCreatePostModalVisible}></CreatePostModal>
        <Navigation setIsCreatePostModalVisible={setIsCreatePostModalVisible} isCreatePostModalVisible={isCreatePostModalVisible} isLoggedIn={isLoggedIn}></Navigation>
    </div>
  )
}

export default Marketplace